import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { getBlogs } from "../../services/productService";
import "./BlogSection.css";

function BlogSection() {

    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        loadBlogs();
    }, []);

    const loadBlogs = async () => {
        try {
            const response = await getBlogs();

            // Show only first 3 blogs on homepage
            setBlogs(response.data.slice(0, 3));

        } catch (error) {
            console.error("Failed to load blogs", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <section className="blog-section">
                <h2 className="blog-title">
                    FarmFox Blog Posts
                </h2>
            </section>
        );
    }

    return (
        <section className="blog-section">

            <h2 className="blog-title">
                FarmFox Blog Posts
            </h2>

            <div className="blog-grid">

                {blogs.map((blog) => (

                    <article
                        key={blog.id}
                        className="blog-card"
                        onClick={() =>
                            navigate(`/blog/${blog.slug}`)
                        }
                    >

                        <div className="blog-image-wrapper">

                            <img
                                src={blog.imageUrl}
                                alt={blog.title}
                                className="blog-image"
                            />

                            {blog.category && (
                                <span className="blog-category">
                                    {blog.category}
                                </span>
                            )}

                        </div>

                        <h3 className="blog-heading">
                            {blog.title}
                        </h3>

                        <p className="blog-description">
                            {blog.description}
                        </p>

                        <div className="blog-date">

                            <CalendarDays size={18} />

                            <span>
                                {blog.publishedDate}
                            </span>

                        </div>

                    </article>

                ))}

            </div>

            <div className="blog-view-all">

                <button
                    className="view-all-btn"
                    onClick={() => navigate("/blogs")}
                >
                    View All →
                </button>

            </div>

        </section>
    );
}

export default BlogSection;